module.exports = __webpack_public_path__ + "img/cover-01.4a026207.jpg";